import gql from 'graphql-tag';

const CREATE_SUBSCRIPTION = gql`
    mutation createSubscription(
        $totalToken: Float!
        $duration: Float!
        $walletAddress: String!
        $networkId: BlockchainNetworks!
    ) {
        createSubscription(
            createSubscriptionInput: {
                totalToken: $totalToken
                duration: $duration
                walletAddress: $walletAddress
                networkId: $networkId
            } 
        )
            {
                id
                walletAddress
                duration
                tickets
                totalToken
                isVerified
                status
                userId
            }        
    }
`;

export default CREATE_SUBSCRIPTION;
